<template>
  <div class="page-wrapper">
    <div class="app-header">
      <div class="header-top" v-show="showTenantModel">
        <div class="hospital-selector" @click="show = true">
          <div class="selector-icon">
            <van-icon name="shop-o" size="20" color="#fff" />
          </div>
          <div class="selector-content">
            <div class="selector-value" :title="selectedHospital">
              {{ selectedHospital || '请选择医院' }}
            </div>
          </div>
          <van-icon name="arrow-down" size="18" color="rgba(255,255,255,0.85)" />
        </div>
      </div>

      <div class="header-status">
        <div class="status-item">
          <div class="status-value">{{ cardInfo.cumulativeFlow }}<small>m³</small></div>
          <div class="status-label">累计流量</div>
        </div>
        <div class="status-divider"></div>
        <div class="status-item">
          <div class="status-value">{{ 4 }}<small>台</small></div>
          <div class="status-label">在线设备</div>
        </div>
        <div class="status-divider"></div>
        <div class="status-item" :class="{ 'danger': cardInfo.pendingAlarm > 0 }">
          <div class="status-value">{{ cardInfo.pendingAlarm }}<small>条</small></div>
          <div class="status-label">待处理告警</div>
        </div>
      </div>
    </div>

    <van-action-sheet v-model="show" :actions="actions" :close-on-click-action="false"
      cancel-text="取消" description="请选择要查看的医院" @select="onSelect"/>

    <div class="content">
      <div class="monitor-section">
        <div class="section-title">实时监测数据</div>
        <div class="status-overview">
          <div class="status-card" v-for="(item, index) in cardInfo.monitorData" :key="index" :class="item.class">
            <div class="status-icon">
              <van-icon :color="item.class === 'status-danger' ? '#FF4D4F' : '#52C41A' " name="clock-o" size="24" />
            </div>
            <div class="status-info">
              <div class="status-label">{{ item.label }}</div>
              <div class="status-reading">
                <span class="status-value">{{ item.value }}</span>
                <span v-if="item.unit" class="status-unit">{{ item.unit }}</span>
              </div>
              <div v-if="item.range" class="status-range">{{ item.range }}</div>
            </div>
          </div>
        </div>
      </div>

      <div class="monitor-section alarm-section">
        <div class="section-title">待处理告警</div>
        <div class="scrollable-list">
          <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
            <van-list
              v-model="loading"
              :finished="finished"
              :finished-text="alarmList.length === 0 ? '' : '没有更多数据了'"
              @load="onLoad"
              :immediate-check="false"
              class="alarm-list"
            >
              <div v-if="alarmList.length === 0 && finished" class="empty-alarm">
                <div class="empty-icon">
                  <van-icon name="success" size="48" color="#52C41A" />
                </div>
                <div class="empty-text">暂无待处理告警</div>
                <div class="empty-subtext">系统运行正常</div>
              </div>
              <AlarmCard
                v-for="(item, index) in alarmList"
                :key="index"
                :item="item"
                status="0"
                @open-handle="handleAlarm"
              />
            </van-list>
          </van-pull-refresh>
        </div>
      </div>
    </div>

    <tabular :active="0" />

    <AlarmDetailPopup
      v-model="dialogVisible"
      mode="handle"
      :alarm-data="formData"
      @submit="submitForm"
    />
  </div>
</template>
<script>
import $ from '@/fly'
import Tabular from '@/components/tabbar.vue';
import AlarmCard from '@/components/alarm/AlarmCard.vue';
import AlarmDetailPopup from '@/components/alarm/AlarmDetailPopup.vue';
import { Toast } from 'vant';
import _ from 'lodash';
import { tenantData } from '@/utils/tenantUtils';

export default {
  name: 'homepage',
  components: { Tabular, AlarmCard, AlarmDetailPopup },
  computed: {
    actions() {
      return this.tenantList.map(tenant => {
        const isSelected = tenant.equCode === this.currentEquCode;
        return {
          name: tenant.tenantName,
          tenant: tenant,
          className: isSelected ? 'is-selected' : '',
          color: isSelected ? '#1B75F6' : ''
        };
      });
    },
    showTenantModel() {
      const roleNames = tenantData.getRoleName()
      return !!(roleNames && (roleNames.includes("运维工程师") || roleNames.includes("管理员")) && tenantData.getTenantModel() === 'SINGLE');
    }
  },
  data () {
    return {
      timer:null,
      refreshing: false,  // 下拉刷新状态
      finished: false,  // 是否加载完成
      loading: false,  //是否加载状态
      show: false,
      tenantList: [],
      currentEquCode: '',
      selectedHospital: '',
      cardInfo: {
        cumulativeFlow: "--",
        pendingAlarm: "0",
        monitorDate:null,
        monitorData: [
          {
            value: "--",
            label: '温度 · 瞬时值',
            class: 'status-normal',
            unit: '℃',
            range: ''
          },
          {
            value: "--",
            label: '流量 · 瞬时值',
            class: 'status-normal',
            unit: 'L/S',
            range: ''
          },
          {
            value: "--",
            label: '总余氯 · 小时均值',
            class: 'status-normal',
            unit: 'mg/L',
            range: '达标 2 ~ 8mg/L'
          },
          {
            value: "--",
            label: 'pH · 小时均值',
            class: 'status-normal',
            unit: '',
            range: '达标 6 ~ 9'
          }
        ]
      },
      alarmList: [],
      // 分页相关
      pageNum: 1,
      pageSize: 10,
      // 表单相关
      dialogVisible: false,
      formData: {},
    }
  },
  methods: {
    onSelect(action) {
      const tenant = action.tenant;
      if (tenant && tenant.equCode) {
        localStorage.setItem('SHOW_TENANT', JSON.stringify(tenant.equCode));
        this.currentEquCode = tenant.equCode;
        this.selectedHospital = tenant.tenantName;
        this.show = false;
        this.getHomeCardData();
        this.onRefresh();
      } else {
        Toast('该医院未配置设备码');
      }
    },
    initHomeData() {
      this.getHomeCardData();
      this.getHomeListData();
      this.timer = setInterval(() => {
        this.getHomeCardData();
      }, 5000);
    },
    // 获取实时监控数据
    getHomeCardData () {
      $.get('mobile/homepage/getCardData',{equCode:this.currentEquCode}).then(res=>{
        const obj = res.data;
        this.cardInfo.pendingAlarm = obj?.pendingAlarm || "0"
        this.cardInfo.cumulativeFlow = obj?.cumulativeFlow || "--"
        this.cardInfo.monitorDate = obj?.monitorTime || null
        this.cardInfo.monitorData = [
          {
            value: obj?.waterTemperature ?? "--",
            label: '温度 · 瞬时值',
            class: 'status-normal',
            unit: '℃',
            range: ''
          },
          {
            value: obj?.flow ?? "--",
            label: '流量 · 瞬时值',
            class: 'status-normal',
            unit: 'L/S',
            range: ''
          },
          {
            value: obj?.chloride ?? "--",
            label: '总余氯 · 小时均值',
            class: this.whetherRange(obj?.chloride,2,8) ? 'status-normal' : 'status-danger',
            unit: 'mg/L',
            range: '达标 2 ~ 8mg/L'
          },
          {
            value: obj?.ph || "--",
            label: 'pH · 小时均值',
            class: this.whetherRange(obj?.ph,6,9) ? 'status-normal' : 'status-danger',
            unit: '',
            range: '达标 6 ~ 9'
          }
        ]
      })
    },
    whetherRange (value,start,end) {
      if (value === null || value === undefined || value === '' || isNaN(value)) {
        return true;
      }
      return value >= start && value <= end;
    },
    getHomeListData(isRefresh) {
      if (!isRefresh) {
        this.loading = true;
      }
      $.get('mobile/homepage/getListData', {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        status: '0',
        equCode: this.currentEquCode || tenantData.getEquCode()
      }).then(res => {
        const list = res.data || [];
        if (this.pageNum === 1) {
          this.alarmList = [...list];
        } else {
          this.alarmList = [...this.alarmList, ...list];
        }
        this.finished = list.length < this.pageSize;
        if (!this.finished) {
          this.pageNum++;
        }
      }).catch(() => {
        this.finished = true;
      }).finally(() => {
        this.loading = false;
        this.refreshing = false;
      });
    },
    // 触底加载
    onLoad() {
      if (!this.finished && !this.refreshing) {
        this.getHomeListData();
      } else {
        this.loading = false;
      }
    },
    // 下拉数据列表刷新
    onRefresh() {
      this.pageNum = 1;
      this.finished = false;
      this.alarmList = [];
      this.$nextTick(() => {
        this.finished = true;
        this.getHomeListData();
      });
    },
    // 重置数据，帮助垃圾回收
    clearHomeData () {
      this.refreshing = false
      this.finished = false
      this.loading = false
      this.cardInfo = {
        cumulativeFlow: "--",
        pendingAlarm: "0",
        monitorDate: null,
        monitorData: [
          {
            value: "--",
            label: '温度 · 瞬时值',
            class: 'status-normal',
            unit: '℃',
            range: ''
          },
          {
            value: "--",
            label: '流量 · 瞬时值',
            class: 'status-normal',
            unit: 'L/S',
            range: ''
          },
          {
            value: "--",
            label: '总余氯 · 小时均值',
            class: 'status-normal',
            unit: 'mg/L',
            range: '达标 2 ~ 8'
          },
          {
            value: "--",
            label: 'pH · 小时均值',
            class: 'status-normal',
            unit: '',
            range: '达标 6 ~ 9'
          }
        ]
      }
      this.alarmList = []
      this.dialogVisible = false
      this.pageNum = 1
      this.pageSize = 10
      this.formData = {}
    },
    // 处理报警
    handleAlarm (item) {
      this.formData = _.cloneDeep(item)
      this.dialogVisible = true;
    },
    // 提交表单
    submitForm(formData) {
      $.post('mobile/alarm/dealAlarm', formData, { contentType: 'application/json' })
        .then(() => {
          this.pageNum = 1;
          this.finished = false;
          this.alarmList = [];
          this.$nextTick(() => {
            this.finished = true;
            this.getHomeListData();
          });
          Toast.success('处理完成！');
        }).finally(() => {
          this.dialogVisible = false;
        })
    }
  },
  mounted () {
    this.tenantList = tenantData.getTenantList();
    const currentEquCode = tenantData.getEquCode();
    if (currentEquCode) {
      this.currentEquCode = currentEquCode;
      const currentTenant = this.tenantList.find(t => t.equCode === currentEquCode);
      if (currentTenant) {
        this.selectedHospital = currentTenant.tenantName;
      }
    }
    this.$nextTick(() => {
      this.initHomeData()
    });
  },
  beforeDestroy () {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
    this.clearHomeData();
  }
}
</script>

<style lang="less" scoped>

.page-wrapper {
  /* 由 #app(height:100%) 撑满，避免 100vh 在移动端地址栏收起时镂空 */
  height: 100%;
  display: flex;
  flex-direction: column;
  background-color: #F5F7FA;
  overflow: hidden;
}

.app-header {
  flex-shrink: 0;
  background: linear-gradient(160deg, #1B75F6 0%, #4A90E2 60%, #6CB4F0 100%);
  padding: 20px 20px 20px;
  border-radius: 0 0 48px 48px;
  box-shadow: 0 10px 36px rgba(27, 117, 246, 0.2);
  color: #fff;
  position: relative;

  .header-top {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 20px;
  }

  .header-status {
    display: flex;
    align-items: center;
    justify-content: space-around;
    background: rgba(255, 255, 255, 0.15);
    backdrop-filter: blur(10px);
    border-radius: 28px;
    padding: 32px 24px;

    .status-item {
      flex: 1;
      text-align: center;

      .status-value {
        font-size: 42px;
        font-weight: bold;
        line-height: 1.2;
        margin-bottom: 8px;
        display: inline-block;
        will-change: transform, opacity;

        small {
          font-size: 26px;
          font-weight: normal;
          opacity: 0.8;
          margin-left: 2px;
        }
      }

      .status-label {
        font-size: 22px;
        opacity: 0.85;
      }

      &.danger {
        .status-value {
          color: #fff;
          animation: pulse-danger 2s ease-in-out infinite;
        }
        .status-label {
          color: #FFE8E8;
          opacity: 1;
        }
      }
    }

    .status-divider {
      width: 1px;
      height: 64px;
      background: rgba(255, 255, 255, 0.25);
    }
  }
}

@keyframes pulse-danger {
  0%, 100% {
    opacity: 1;
    transform: scale(1);
    color: #FF4D4F;
  }
  50% {
    opacity: 0.85;
    transform: scale(1.08);
    color: #FF7875;
  }
}

.hospital-selector {
  display: flex;
  align-items: center;
  flex: 1;
  min-width: 0;
  padding: 14px 20px;
  background: rgba(255, 255, 255, 0.15);
  border-radius: 20px;
  cursor: pointer;
  transition: background 0.2s;

  &:active {
    background: rgba(255, 255, 255, 0.25);
  }

  .selector-icon {
    width: 48px;
    height: 48px;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.22);
    border: 1px solid rgba(255, 255, 255, 0.3);
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 14px;
    flex-shrink: 0;
  }

  .selector-content {
    flex: 1;
    min-width: 0;
  }

  .selector-value {
    font-size: 28px;
    font-weight: 600;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}

.content {
  padding: 20px 24px;
  position: relative;
  z-index: 1;
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.monitor-section {
  background: white;
  border-radius: 24px;
  padding: 32px 24px;
  margin-bottom: 24px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.04);
  flex-shrink: 0;

  &.alarm-section {
    flex: 1;
    display: flex;
    flex-direction: column;
    margin-bottom: 0;
    overflow: hidden;
    min-height: 0;
  }

  .section-title {
    font-size: 24px;
    font-weight: bold;
    margin-bottom: 24px;
    color: #1a365d;
    display: flex;
    align-items: center;
    flex-shrink: 0;

    &::before {
      content: '';
      display: inline-block;
      width: 6px;
      height: 30px;
      background: linear-gradient(to bottom, #1B75F6, #4A90E2);
      border-radius: 3px;
      margin-right: 12px;
    }
  }
}

.status-overview {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;

  .status-card {
    background: #F8FAFC;
    border-radius: 20px;
    padding: 24px;
    display: flex;
    align-items: center;
    transition: all 0.2s ease;

    &:active {
      transform: scale(0.98);
    }

    &.status-danger {
      background: linear-gradient(135deg, #FFF5F5 0%, #FFE8E8 100%);

      .status-value {
        color: #FF4D4F;
        animation: pulse-danger 2s ease-in-out infinite;
      }

      .status-label {
        color: #CF1322;
      }

      .status-unit {
        color: #FF7875;
      }
    }

    &.status-normal {
      background: linear-gradient(135deg, #F0FFF4 0%, #E8F8EE 100%);
    }

    .status-icon {
      width: 64px;
      height: 64px;
      border-radius: 50%;
      background: #fff;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-right: 16px;
      flex-shrink: 0;
      box-shadow: 0 4px 10px rgba(0, 0, 0, 0.06);
    }

    .status-info {
      flex: 1;
      min-width: 0;

      .status-label {
        font-size: 22px;
        color: #6B7280;
        margin-bottom: 6px;
      }
    }

    /* 数值与单位同基线排列，避免单位单独占一行把卡片撞得很高 */
    .status-reading {
      display: flex;
      align-items: baseline;
      gap: 4px;
      min-width: 0;

      .status-value {
        font-size: 34px;
        font-weight: bold;
        color: #1F2937;
        line-height: 1.2;
      }

      .status-unit {
        font-size: 20px;
        color: #9CA3AF;
        flex-shrink: 0;
      }
    }

    .status-range {
      font-size: 18px;
      color: #9CA3AF;
      margin-top: 2px;
      min-height: 24px;
    }
  }
}

/* 列表区高度由 flex 分配，不再用 JS 测量高度 */
.scrollable-list {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;

  ::v-deep .van-pull-refresh {
    flex: 1;
    min-height: 0;
    display: flex;
    flex-direction: column;
  }

  ::v-deep .van-pull-refresh__track {
    flex: 1;
    min-height: 0;
  }
}

.alarm-list {
  height: 100%;
  min-height: 0;
  overflow-y: auto;

  &::-webkit-scrollbar {
    width: 0;
  }
  -ms-overflow-style: none;
  scrollbar-width: none;
}
.empty-alarm {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 80px 32px;
  text-align: center;

  .empty-icon {
    margin-bottom: 24px;
  }

  .empty-text {
    font-size: 26px;
    font-weight: bold;
    color: #374151;
    margin-bottom: 12px;
  }

  .empty-subtext {
    font-size: 22px;
    color: #9CA3AF;
  }
}

/deep/.van-action-sheet__action {
  font-size: 26px;
  height: 88px;
  line-height: 88px;

  &.is-selected {
    font-weight: 600;
    position: relative;
    background: linear-gradient(135deg, rgba(27, 117, 246, 0.08) 0%, rgba(74, 144, 226, 0.05) 100%);
    border-top: 1px solid rgba(27, 117, 246, 0.1);
    border-bottom: 1px solid rgba(27, 117, 246, 0.1);
  }

  &.is-selected::before {
    content: '';
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    width: 6px;
    height: 36px;
    background: linear-gradient(to bottom, #1B75F6, #4A90E2);
    border-radius: 0 4px 4px 0;
  }

  &.is-selected::after {
    content: '\2713';
    position: absolute;
    right: 32px;
    top: 50%;
    transform: translateY(-50%);
    color: #1B75F6;
    font-weight: bold;
    font-size: 32px;
  }
}
</style>
